import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { type Observable } from 'rxjs';
import { type TowingIncident } from './towing-incident.model';

@Injectable({ providedIn: 'root' })
export class TowingIncidentService {
  private readonly http = inject(HttpClient);

  load(lang?: string): Observable<TowingIncident> {
    let params = new HttpParams();
    if (lang) {
      params = params.set('lang', lang);
    }

    return this.http.get<TowingIncident>(`api/v1/tickets/towing/workups/current`, { params });
  }
}
